<template>
    <div class="overflow-hidden border border-gray-300 rounded-md">
        <div class="flex items-center bg-gray-100">
            <div class="w-10/12 py-2 px-2 font-bold">Название</div>
            <div class="w-2/12 py-2 px-2 font-bold">Активен</div>
        </div>

        <div
            v-for="item in list"
            :key="item.id"
            class="flex items-center border-t border-gray-300"
        >
            <div class="w-10/12 truncate px-2 py-2">
                <span
                        class="text-purple-700 cursor-pointer hover:underline"
                        :title="item.route_name"
                        @click="$emit('select', item.id)"
                    >{{ item.title }}
                </span>
            </div>
            <div class="w-2/12 px-2">
                <CBadge :color="item.enabled ? 'success' : 'secondary'">
                    {{ item.enabled ? "Да" : "Нет" }}
                </CBadge>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        components: {
        },

        props: {
            data: {
                type: Array,
                default: () => [],
            },
        },

        data: () => ({
        }),

        computed: {
            list: {
                get() {
                    return this.data;
                }
            },
        },

        async mounted() {
        },

        methods: {
        },
    };
</script>
